// import React, { useEffect, useRef, useState } from "react";
// import blinkshare from "../../../assets/patientcharts/blinkscribe 2.svg";
// import recordbutton from "../../../assets/patientcharts/recordbutton.png";
// import redwave from "../../../assets/patientcharts/redwave.png";
// import messageIcon from "../../../assets/patientcharts/mingcute_more-3-fill.svg";
// import TypeofVisitPop from "./TypeofVisitPop";
// import { useNavigate } from "react-router-dom";
// import redcircle from "../../../assets/audio/redcircle.png";
// import pause from "../../../assets/audio/Pause.png";
// import play from "../../../assets/audio/play.png";
// import stop from "../../../assets/audio/ion_stop.png";
// import redmic from "../../../assets/audio/redmic.png";
// import ExitModal from "../overlays/exitmodal";
// import ReactiveWaves from "../../../streaming/reactivewaves";
// import blinkscribeapi from "../../../api/blinkscribeapi";
// import DeleteConfirmation from "../overlays/deleteconformation";
// import useAudioRecorder from "../../../blinkscribe/audiorecorderhook";
// import { Backdrop, CircularProgress } from "@mui/material";
// import NurseAssistant from "../../../../src/assets/Signin/nurseassistant.svg";
// import api from "../../../api/api";
// import TimerOffIcon from "@mui/icons-material/TimerOff";
// import { eventBus } from "../../../utils/eventBus";
// import ToastMessage from "../../../utils/mui/righttoptoast";
// import { useSelector } from "react-redux";
// import { ChatIcon, GoogleIcon, orangetick } from "./svg";
// import ConfirmReviewModal from "./googleModal";
// import { set } from "date-fns";
// import dayjs from "dayjs";
// import { useRecording } from "../../../context/RecordingContext";

// const SideFrame = ({
//   audiotabchange,
//   onClose,
//   currentTab,
//   isreocrdingdisabled,
//   fetchpcarddata,
//   data,
//   setChat,
// }) => {
//   const [percentage, setPercentage] = useState(20);
//   const [activeButton, setActiveButton] = useState(3);
//   const [loading, setLoading] = useState(false);
//   const [TypeofVisit, setTypeofVisit] = useState(false);
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const practiseid = window.getPracticeId();
//   const [initialData, setInitialData] = useState([]);
//   const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
//   const [showTooltip, setShowTooltip] = useState(false);
//   const [showTick, setShowTick] = useState(false);

//   const lovValue = useSelector(
//     (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
//   );
//   const tovValue = useSelector(
//     (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
//   );
//   const homescreenprev = useSelector(
//     (state) => state.userPrivileges.homescreen
//   );
//   const navigate = useNavigate();

//   const [exitModal, setExitModal] = useState(false);
//   const [pollTrigger, setPollTrigger] = useState(0);
//   const pollRef = useRef(null);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [deleteconfirmationModal, setDeleteConfirmationModal] = useState(false);
//   const [isError, setIsError] = useState(false);

//   const lov2Value = useSelector(
//     (state) => state.dump.storedvalues.find((item) => item.id === "lov2")?.value
//   );
//   const tov2Value = useSelector(
//     (state) => state.dump.storedvalues.find((item) => item.id === "tov2")?.value
//   );
//   const orders = useSelector((state) => state.orders.orders);
//   const [alertMode, setAlertMode] = useState(true);
//   const token = localStorage.getItem("auth");
//   const [openToast, setOpenToast] = useState(false);
//   const [toastMessage, setToastMessage] = useState("");
//   const [toastSeverity, setToastSeverity] = useState("success");
//   const [showPopup, setShowPopup] = useState(false);

//   // === Global Recording Context ===
//   const {
//     isGlobalRecording,
//     isGlobalPaused,
//     globalElapsedTime,
//     audioStreamRef,
//     startRecording: contextStartRecording,
//     stopRecording: contextStopRecording,
//     togglePause: contextTogglePause,
//     onSave: contextOnSave,
//     onDelete: contextOnDelete,
//     submitAudioBlobManually,
//     setShowFloatingPopup,
//     setIsOnRecordingPage,
//     registerManualRecording,
//     showToastRef,
//     setPollTriggerRef,
//     combineStatusRef,
//     latestAppRef,
//     streamNameRef,
//     stopTimer: contextStopTimer,
//     pausedRef,
//   } = useRecording();

//   // Local aliases for readability (these come from global context now)
//   const isRecording = isGlobalRecording;
//   const isPaused = isGlobalPaused;
//   const elapsedTime = globalElapsedTime;

//   const handleToastClose = () => {
//     setOpenToast(false);
//   };

//   // Provide manual audio blob handler to context
//   const onSaving = (blob) => {
//     submitAudioBlobManually(blob);
//   };

//   const {
//     manualrecord,
//     stopmanualRecording,
//     pausemanualRecording,
//     resumemanualRecording,
//   } = useAudioRecorder(onSaving);

//   // Register manual recording hooks with the global context
//   useEffect(() => {
//     registerManualRecording({
//       manualrecord,
//       stopmanualRecording,
//       pausemanualRecording,
//       resumemanualRecording,
//     });
//   }, [manualrecord, stopmanualRecording, pausemanualRecording, resumemanualRecording]);

//   // Register toast callback with context
//   useEffect(() => {
//     showToastRef.current = (message, severity) => {
//       setToastMessage(message);
//       setToastSeverity(severity);
//       setOpenToast(true);
//     };
//     setPollTriggerRef.current = setPollTrigger;
//   }, []);

//   // Mark that user is on the recording page
//   useEffect(() => {
//     setIsOnRecordingPage(true);
//     setShowFloatingPopup(false);
//     return () => {
//       setIsOnRecordingPage(false);
//       // Show floating popup when user leaves this page while recording is active
//       // We read from isGlobalRecording directly can be stale, so use a small trick
//     };
//   }, []);

//   // Track recording state for cleanup
//   const isRecordingRef = useRef(false);
//   useEffect(() => {
//     isRecordingRef.current = isRecording;
//   }, [isRecording]);

//   // When component unmounts while recording, show popup
//   useEffect(() => {
//     return () => {
//       if (isRecordingRef.current) {
//         setShowFloatingPopup(true);
//       }
//     };
//   }, []);

//   const handleButtonClick = (index) => {
//     setActiveButton(index);
//   };

//   const toggleCollapse = () => {
//     setIsCollapsed(!isCollapsed);
//   };

//   const circleStyle = {
//     background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${
//       percentage * 3.6
//     }deg)`,
//   };

//   const togglePause = () => {
//     contextTogglePause();
//   };

//   const formatTime = (seconds) => {
//     const minutes = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
//       2,
//       "0"
//     )}`;
//   };

//   const onExit = () => {
//     setExitModal(false);
//     contextOnSave();
//   };

//   const deleteStream = async () => {
//     setExitModal(false);
//     setDeleteConfirmationModal(false);
//     await contextOnDelete();
//   };

//   const angle = percentage * 3.6;
//   const radians = (angle - 90) * (Math.PI / 180);
//   const radius = 35;
//   const smallCircleOffset = 8;

//   const smallCircleStyle = {
//     position: "absolute",
//     top: `${60 + radius * Math.sin(radians) - smallCircleOffset}px`,
//     left: `${60 + radius * Math.cos(radians) - smallCircleOffset}px`,
//     width: "28px",
//     height: "28px",
//     backgroundColor: "#FFFFFF",
//     borderRadius: "50%",
//     transform: "translate(-50%, -50%)",
//     boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
//   };

//   const handleAlarmData = async ({ PateintData }, AlertCondition) => {
//     try {
//       const response = await api.put(
//         `/v1/${practiseid}/checkin/patient/${PateintData.patientid}/update_alarm_alert`,
//         {
//           appointment_id: PateintData.appointmentid,
//           emergency_alert: AlertCondition,
//         }
//       );
//       if (response.status === 200) {
//         console.log("Updated Successfully");
//         handleAlertModeData(PateintData);
//       } else {
//         console.error("Failed ");
//       }
//     } catch (error) {
//       console.error("Error unassigning room:", error);
//     }
//   };

//   const handleAlertModeData = async (PateintData) => {
//     try {
//       const response = await api.post(
//         `/v1/${practiseid}/checkin/patient/${PateintData.patientid}/get_sign_details`,
//         {
//           appointment_id: PateintData.appointmentid,
//         }
//       );
//       if (response.status === 200) {
//         console.log("Updated Successfully");
//         setAlertMode(response.data?.emergency_alert);
//       } else {
//         console.error("Failed ");
//       }
//     } catch (error) {
//       console.error("Error unassigning room:", error);
//     }
//   };

//   useEffect(() => {
//     const payload = {
//       filter_array: {
//         date_filter: {
//           start_date: dayjs().format("YYYY-MM-DD"),
//           end_date: dayjs().format("YYYY-MM-DD"),
//         },
//       },
//     };

//     const checkRecording = async () => {
//       const res = await blinkscribeapi.post(
//         `/v1/patient/${data.patientid}/recording/details`,
//         payload
//       );
//       console.log("checking for summarized");
//       if (res.status !== 200) return;

//       const list = res.data || [];

//       if (!list.length) {
//         setShowTick(false);
//         return;
//       }

//       const latest = list.sort(
//         (a, b) => dayjs(b.ts).valueOf() - dayjs(a.ts).valueOf()
//       )[0];

//       if (latest.transcriptionstatus === "Summarized") {
//         setShowTick(true);
//         clearInterval(pollRef.current);
//       } else {
//         setShowTick(false);
//       }
//     };

//     checkRecording();
//     pollRef.current = setInterval(checkRecording, 3000);

//     return () => clearInterval(pollRef.current);
//   }, [data.patientid, pollTrigger]);

//   const handleProviderShow = async ({ ProviderData }) => {
//     try {
//       const response = await api.put(
//         `/v1/${practiseid}/checkin/patient/${ProviderData.patientid}/update_provider`,
//         {
//           appointment_id: ProviderData.appointmentid,
//           provider_check: "true",
//         }
//       );
//       if (response.status === 200) {
//         console.log("Updated ProviderName Successfully");
//       } else {
//         console.error("Failed to Updated ProviderName Successfully");
//       }
//     } catch (error) {
//       console.error("Error unassigning room:", error);
//     }
//   };

//   const fetchData = async () => {
//     try {
//       const response = await api.get(
//         `/v1/${practiseid}/orders/patient/${data?.patientid}/condition`
//       );
//       if (response.status === 200) {
//         setInitialData(response.pConditions);
//       }
//     } catch (error) {
//       console.error("Error fetching patient conditions:", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const FetchRecorderData = async () => {
//     try {
//       setLoading(true);
//       const payload = {
//         filter_array: {
//           date_filter: {
//             start_date: dayjs().format("YYYY-MM-DD"),
//             end_date: dayjs().format("YYYY-MM-DD"),
//           },
//         },
//       };

//       const res = await blinkscribeapi.post(
//         `/v1/patient/${data.patientid}/recording/details`,
//         payload
//       );

//       if (res.status === 200) {
//         return res.data || [];
//       }
//       return [];
//     } catch (err) {
//       console.log("FetchRecorderData error:", err);
//       return [];
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkappointments = async () => {
//     try {
//       setLoading(true);
//       const recordings = await FetchRecorderData();

//       if (!recordings.length) {
//         combineStatusRef.current = false;
//         const result = await contextStartRecording(data, token, false, "");
//         if (result.success) setLoading(false);
//         return;
//       }

//       const currentAppointments = recordings.filter(
//         (x) => x.appointmentid == data.appointmentid
//       );

//       if (!currentAppointments.length) {
//         combineStatusRef.current = false;
//         const result = await contextStartRecording(data, token, false, "");
//         if (result.success) setLoading(false);
//         return;
//       }

//       const latest = currentAppointments.reduce((a, b) =>
//         dayjs(b.ts).isAfter(dayjs(a.ts)) ? b : a
//       );

//       const isToday = dayjs(latest.ts).isSame(dayjs(), "day");
//       const hasAudio = !!latest.audiolink;

//       if (isToday && hasAudio) {
//         latestAppRef.current = latest;
//         combineStatusRef.current = true;
//         await contextStartRecording(data, token, true, latest);
//       } else {
//         combineStatusRef.current = false;
//         await contextStartRecording(data, token, false, "");
//       }
//     } catch (error) {
//       console.log("checkappointments error:", error);
//       setToastMessage("Something went wrong.");
//       setToastSeverity("info");
//       setOpenToast(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlestartrecording = () => {
//     const today = dayjs().startOf("day");
//     const apptDate = dayjs(data.startdate, "YYYY-MM-DD HH:mm:ss").startOf(
//       "day"
//     );

//     if (apptDate.isAfter(today)) {
//       setToastMessage("Recording for future dates is not allowed.");
//       setToastSeverity("info");
//       setOpenToast(true);
//       return;
//     }

//     checkappointments();
//   };

//   const trigeerReview = async () => {
//     setLoading(true);
//     try {
//       const response = await api.post(
//         `/v1/${practiseid}/patient/${data?.patientid}/notification/google-review`
//       );
//       if (response.status === 200) {
//         setToastSeverity("success");
//         setToastMessage(response?.message || "Notification Sent Successfully");
//         setOpenToast(true);
//       } else {
//         setToastSeverity("info");
//         setToastMessage(response?.message || "something went wrong");
//         setOpenToast(true);
//       }
//     } catch (error) {
//       console.log(error);
//       setToastSeverity("error");
//       setToastMessage(error?.message || "something went wrong");
//       setOpenToast(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <div
//         className={`relative flex  lg:flex-col items-center lg:gap-4 gap-8 p-4 h-full bg-[#fafaf9] shadow-[0px_14px_42px_rgba(8,15,52,0.06)] transition-all duration-300 ease-in-out ${
//           isCollapsed ? "w-16 lg:w-16" : "w-full lg:w-auto h-[100vh]"
//         }`}
//       >
//         {/* Orange Slider Button */}
//         <button
//           onClick={toggleCollapse}
//           className="absolute bottom-2 left-12 lg:bottom-auto lg:top-4 lg:left-auto lg:-right-3 w-6 h-6 bg-[#E17954] rounded-full flex items-center justify-center shadow-lg transition-colors duration-500 z-2"
//         >
//           <svg
//             className={`w-4 h-4 text-white transition-transform duration-300 ${
//               isCollapsed ? "rotate-180" : "rotate-0"
//             }`}
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M15 19l-7-7 7-7"
//             />
//           </svg>
//         </button>

//         {!isCollapsed && (
//           <div className="w-[20%] lg:w-auto items-center flex flex-col">
//             <div
//               className="absolute top-6 cursor-pointer group left-6"
//               onClick={() => setShowPopup(true)}
//             >
//               {GoogleIcon}
//               <div
//                 className="
//                  pointer-events-none
//       absolute top-1/2 -translate-y-1/2
//       left-8 lg:-left-3 lg:top-10
//      bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md
//       opacity-0 group-hover:opacity-100 transition-opacity duration-200
//       whitespace-nowrap z-50
//     "
//               >
//                 Google Review
//               </div>
//             </div>
//             <div
//               onClick={() => {
//                 setChat(true);
//               }}
//               className="absolute top-6 lg:top-16 left-16 lg:left-6 group cursor-pointer"
//             >
//               {ChatIcon}
//               <div
//                 className="
//                  pointer-events-none
//       absolute top-1/2 -translate-y-1/2
//       left-8 lg:-left-3 lg:top-10
//      bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md
//       opacity-0 group-hover:opacity-100 transition-opacity duration-200
//       whitespace-nowrap
//     "
//               >
//                 Chat
//               </div>
//             </div>

//             <div
//               className="relative flex justify-center items-center w-[90px] h-[90px] mt-1 mb-0"
//               onMouseMove={(e) => {
//                 const rect = e.currentTarget.getBoundingClientRect();
//                 setTooltipPos({
//                   x: e.clientX - rect.left,
//                   y: e.clientY - rect.top + 15,
//                 });
//               }}
//               onMouseEnter={() => setShowTooltip(true)}
//               onMouseLeave={() => setShowTooltip(false)}
//             >
//               <div
//                 onClick={() => {
//                   if (homescreenprev.includes("P-Card")) {
//                     fetchpcarddata(data.id);
//                     onClose();
//                   }
//                 }}
//                 className="relative cursor-pointer flex justify-center items-center"
//               >
//                 <img
//                   src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
//                   alt="profile"
//                   onError={(e) =>
//                     (e.target.src =
//                       "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
//                   }
//                   className="flex justify-center items-center w-[65px] h-[65px] border-2 rounded-[14px]"
//                   style={{ border: `3.5px solid #${data.deductiblemet}` }}
//                 />
//                 {showTick && (
//                   <div
//                     className="absolute -top-2 -right-2 w-6 h-6 rounded-full
//                     flex justify-center items-center bg-[#E17954]"
//                   >
//                     {orangetick}
//                   </div>
//                 )}
//               </div>

//               {showTooltip && (
//                 <div
//                   className="absolute bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md pointer-events-none whitespace-nowrap"
//                   style={{
//                     left: tooltipPos.x,
//                     top: tooltipPos.y,
//                     transform: "translate(-50%, 0)",
//                   }}
//                 >
//                   Pcard
//                 </div>
//               )}
//             </div>

//             <div className="flex flex-col items-center mb-0">
//               <div className="font-bold text-[#202020] text-sm text-center">
//                 {data?.firstname + " " + data.lastname || "-"}
//               </div>
//               <div className="font-medium text-[#7e7e7e] text-[13px] text-center ">
//                 #{data?.patientid || "-"}
//               </div>
//               <div className="font-medium text-[#7e7e7e] text-[13px] text-center ">
//                 {data?.dob || "-"}
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Collapsed State - Show only essential elements */}
//         {isCollapsed && (
//           <div className="flex flex-col items-center mt-6 h-full w-full gap-4">
//             <div
//               className="cursor-pointer group"
//               onClick={() => setShowPopup(true)}
//             >
//               {GoogleIcon}
//               <div
//                 className="
//                  pointer-events-none
//       absolute top-1/2 -translate-y-1/2
//       left-8 lg:-left-3 lg:top-10
//      bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md
//       opacity-0 group-hover:opacity-100 transition-opacity duration-200
//       whitespace-nowrap z-50
//     "
//               >
//                 Google Review
//               </div>
//             </div>
//             <div className="relative group cursor-pointer">
//               {ChatIcon}
//               <div className=" pointer-events-none absolute left-1/2 -translate-x-1/2 -top-8 bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
//                 Chat
//               </div>
//             </div>

//             {/* Profile Picture - Smaller version */}
//             <div className="relative flex justify-center items-center w-[50px] h-[50px]">
//               <div
//                 onClick={() => {
//                   if (homescreenprev.includes("P-Card")) {
//                     fetchpcarddata(data.id);
//                     onClose();
//                   }
//                 }}
//                 className="relative flex justify-center cursor-pointer items-center"
//               >
//                 <img
//                   src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
//                   alt="profile"
//                   onError={(e) =>
//                     (e.target.src =
//                       "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
//                   }
//                   className="flex justify-center items-center w-[45px] h-[45px]  border-2 border-[pink] rounded-[14px]  "
//                   style={{ border: `2px solid #${data.deductiblemet}` }}
//                 />
//               </div>
//             </div>

//             {!isRecording ? (
//               <div className="flex">
//                 <div
//                   className={`w-10 h-10 cursor-pointer ${
//                     isreocrdingdisabled
//                       ? "opacity-50 pointer-events-none"
//                       : ""
//                   }`}
//                   onClick={() => {
//                     if (!isreocrdingdisabled) {
//                       handleProviderShow({ ProviderData: data });
//                       handlestartrecording();
//                     }
//                   }}
//                 >
//                   <img src={redmic} className="w-[35px] h-[35px]" alt="Mic" />
//                 </div>
//               </div>
//             ) : (
//               <div className="flex flex-col items-center gap-2">
//                 <div className="relative cursor-pointer" onClick={togglePause}>
//                   <img
//                     src={redcircle}
//                     alt="Red Circle"
//                     className="w-[30px] h-[30px]"
//                   />
//                   <img
//                     src={!isPaused ? pause : play}
//                     alt="Pause/Play"
//                     className="absolute inset-0 m-auto w-[15px] h-[15px]"
//                   />
//                 </div>
//                 <div
//                   className="text-black font-normal text-xs"
//                   style={{ fontFamily: "Inter" }}
//                 >
//                   {formatTime(elapsedTime)}
//                 </div>
//                 <div
//                   className="relative cursor-pointer"
//                   onClick={() => {
//                     if (!isPaused) {
//                       contextStopTimer();
//                       pausedRef.current = false;
//                       contextTogglePause();
//                     }
//                     setExitModal(true);
//                   }}
//                 >
//                   <img
//                     src={redcircle}
//                     alt="Red Circle"
//                     className="w-[30px] h-[30px]"
//                   />
//                   <img
//                     src={stop}
//                     alt="Stop"
//                     className="absolute inset-0 m-auto w-[15px] h-[15px]"
//                   />
//                 </div>
//               </div>
//             )}

//             {/* User Icon */}
//             <div
//               className="flex justify-center items-center w-8 h-8 cursor-pointer hover:bg-gray-100 rounded-lg transition-colors duration-200"
//               onClick={toggleCollapse}
//             >
//               <svg
//                 width="19"
//                 height="18"
//                 viewBox="0 0 19 18"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M9.5 16.5C13.6421 16.5 17 13.1421 17 9C17 4.85786 13.6421 1.5 9.5 1.5C5.35786 1.5 2 4.85786 2 9C2 13.1421 5.35786 16.5 9.5 16.5Z"
//                   stroke="#202224"
//                   strokeWidth="1.5"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//                 <path
//                   d="M9.5 9.75C10.7426 9.75 11.75 8.74264 11.75 7.5C11.75 6.25736 10.7426 5.25 9.5 5.25C8.25736 5.25 7.25 6.25736 7.25 7.5C7.25 8.74264 8.25736 9.75 9.5 9.75Z"
//                   stroke="#202224"
//                   strokeWidth="1.5"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//                 <path
//                   d="M5.75 15.4965V14.25C5.75 13.8522 5.90804 13.4706 6.18934 13.1893C6.47064 12.908 6.85218 12.75 7.25 12.75H11.75C12.1478 12.75 12.5294 12.908 12.8107 13.1893C13.092 13.4706 13.25 13.8522 13.25 14.25V15.4965"
//                   stroke="#202224"
//                   strokeWidth="1.5"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//               </svg>
//             </div>

//             {/* Calendar Icon */}
//             <div
//               className="flex justify-center items-center w-8 h-8 cursor-pointer hover:bg-gray-100 rounded-lg transition-colors duration-200"
//               onClick={toggleCollapse}
//             >
//               <svg
//                 width="21"
//                 height="20"
//                 viewBox="0 0 21 20"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M7.1665 1.66669V5.00002"
//                   stroke="#1E2A4A"
//                   strokeWidth="1.66667"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//                 <path
//                   d="M13.8335 1.66669V5.00002"
//                   stroke="#1E2A4A"
//                   strokeWidth="1.66667"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//                 <path
//                   d="M16.3333 3.33331H4.66667C3.74619 3.33331 3 4.07951 3 4.99998V16.6666C3 17.5871 3.74619 18.3333 4.66667 18.3333H16.3333C17.2538 18.3333 18 17.5871 18 16.6666V4.99998C18 4.07951 17.2538 3.33331 16.3333 3.33331Z"
//                   stroke="#1E2A4A"
//                   strokeWidth="1.66667"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//                 <path
//                   d="M3 8.33331H18"
//                   stroke="#1E2A4A"
//                   strokeWidth="1.66667"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//               </svg>
//             </div>

//             {/* Number Button */}
//             <div className="flex justify-center items-center">
//               <button
//                 className={`w-8 h-8 rounded-lg shadow-[0px_0px_4px_2px_#0000001a] flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity duration-200 ${
//                   lovValue === 3
//                     ? "bg-[#e17954] text-white"
//                     : "bg-white text-[#1d2951]"
//                 }`}
//                 onClick={toggleCollapse}
//               >
//                 <div className="font-bold text-xs">{lovValue}</div>
//               </button>
//             </div>

//             {/* DX Text */}
//             <div
//               className="flex justify-center items-center cursor-pointer hover:bg-gray-100 rounded-lg transition-colors duration-200 px-2 py-1"
//               onClick={toggleCollapse}
//             >
//               <div className="text-[#1E2A4A] font-medium text-xs font-font1 ">
//                 DX
//               </div>
//             </div>
//           </div>
//         )}

//         {!isCollapsed && (
//           <div className="flex-grow flex lg:flex-col lg:gap-0 gap-10 items-center  lg:border-t-2 max-h-[65%] thin-visible-scrollbar">
//             <div>
//               <div className="w-full flex justify-center items-center p-0 mt-2 mb-2">
//                 <img
//                   src={blinkshare}
//                   alt=""
//                   className="max-w-full max-h-[150px] object-contain"
//                 />
//               </div>
//               <div className="w-full flex justify-center items-center">
//                 {!isRecording ? (
//                   <div className="flex">
//                     <div className="w-12 h-12 cursor-pointer">
//                       <div
//                         className={` ${
//                           isreocrdingdisabled
//                             ? "opacity-50 pointer-events-none"
//                             : " cursor-pointer"
//                         }`}
//                         onClick={() => {
//                           if (!isreocrdingdisabled) {
//                             handleProviderShow({ ProviderData: data });
//                             handlestartrecording();
//                           }
//                         }}
//                       >
//                         <img
//                           src={redmic}
//                           className="w-[40px] h-[40px] md:w-[50px] md:h-[50px]"
//                           alt="Mic"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="flex gap-4 items-center">
//                     <div
//                       className="relative cursor-pointer"
//                       onClick={togglePause}
//                     >
//                       <img
//                         src={redcircle}
//                         alt="Red Circle"
//                         className="w-[35px] h-[35px]"
//                       />
//                       <img
//                         src={!isPaused ? pause : play}
//                         alt="Pause/Play"
//                         className="absolute inset-0 m-auto w-[20px] h-[20px]"
//                       />
//                     </div>

//                     <div className="flex flex-col items-center h-[90%] justify-between">
//                       <div className="h-4 overflow-hidden">
//                         <ReactiveWaves
//                           isPaused={!isPaused}
//                           mediaStream={audioStreamRef.current}
//                         />
//                       </div>
//                       <div
//                         className="h-3 text-black font-normal"
//                         style={{ fontFamily: "Inter" }}
//                       >
//                         {formatTime(elapsedTime)}
//                       </div>
//                     </div>

//                     <div
//                       className="relative cursor-pointer"
//                       onClick={() => {
//                         if (!isPaused) {
//                           contextStopTimer();
//                           pausedRef.current = false;
//                           contextTogglePause();
//                         }
//                         setExitModal(true);
//                       }}
//                     >
//                       <img
//                         src={redcircle}
//                         alt="Red Circle"
//                         className="w-[35px] h-[35px]"
//                       />
//                       <img
//                         src={stop}
//                         alt="Stop"
//                         className="absolute inset-0 m-auto w-[20px] h-[20px]"
//                       />
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//             {/* content */}
//             <div className="flex lg:flex-col lg:gap-0 gap-10">
//               <div>
//                 <div className="flex flex-col items-start w-full mt-1">
//                   <div className="font-medium  text-[#7e7e7e] text-[13px]">
//                     Healthcare
//                   </div>
//                   <div className="font-medium break text-left text-[#202020] text-sm mt-1 text-[17.5px]">
//                     {data?.insurancename || "-"}
//                   </div>
//                 </div>
//                 <div className="flex flex-col items-start w-full mt-2">
//                   <div className="font-medium text-[#7e7e7e] text-[12px]">
//                     Provider
//                   </div>
//                   <div className="font-medium text-[#202020] text-sm mt-1">
//                     {data?.linked_provider || "-"}
//                   </div>
//                 </div>
//                 <div className="flex flex-col items-start w-full mt-2">
//                   <div className="font-medium text-[#7e7e7e] text-[12px]">
//                     Type of Visit
//                   </div>
//                   <div className="font-medium text-[#202020] text-sm mt-1 flex justify-between w-full">
//                     <div>{tovValue || "-"}</div>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="flex flex-col items-start w-full mt-2">
//                   <div className="font-medium text-[#7e7e7e] text-[13px]">
//                     Level Of Visit
//                   </div>
//                   <div className="flex items-center gap-1 px-1 py-1">
//                     {[1, 2, 3, 4, 5].map((number) => (
//                       <button
//                         key={number}
//                         className={`w-9 h-[32px] flex items-center justify-center rounded-lg border-[1px] border-gray-200 shadow-[0px_0px_4px_2px_#0000001a] ${
//                           lovValue === number
//                             ? "bg-[#e17954] text-white"
//                             : "bg-white text-[#1d2951]"
//                         }`}
//                         style={{ left: `${(number - 1) * 30}px` }}
//                       >
//                         <div className="font-bold text-[10px] text-center">
//                           {number}
//                         </div>
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//             {tov2Value && (
//               <div className="flex flex-col items-start w-full my-2 px-2">
//                 <div className="font-medium text-[#7e7e7e] text-[12px]">
//                   Type of Visit
//                 </div>
//                 <div className="flex items-center w-fit px-3 py-1 my-1 rounded-full border-[1px] border-[#E17954] bg-[#E179542E]">
//                   <span className="text-xs font-medium font-inter text-[#7E7E7E]">
//                     {tov2Value || "-"}
//                   </span>
//                   <span className="ml-2 flex items-center justify-center w-6 h-6 rounded-full bg-[#E17954] text-white text-xs font-bold shadow-sm">
//                     {lov2Value || "-"}
//                   </span>
//                 </div>
//               </div>
//             )}

//             {orders?.diagnosis &&
//               orders.diagnosis.length > 0 &&
//               !isCollapsed && (
//                 <div className="[font-family:'Tahoma'] flex flex-column items-center py-1 text-[#1d2951] text-xs leading-[normal]">
//                   <div>
//                     <div className="flex justify-between font-inter items-center sm:w-[190px]">
//                       DIAGNOSIS
//                       <div></div>
//                     </div>
//                   </div>
//                   <div className="mt-2 max-h-[90px] overflow-y-auto  bg-gray-40 rounded-[10px] border-[1.5px] border-gray-100 mx-2">
//                     <ul className="list-disc pl-4 cursor-pointer ">
//                       {orders.diagnosis.map((condition) => (
//                         <li
//                           key={condition.id}
//                           className="font-semibold text-left text-[#4B5563] text-xs font-thin mb-2 my-2"
//                         >
//                           <strong>{condition.condition_name}</strong>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//               )}
//           </div>
//         )}
//       </div>
//       <Backdrop
//         sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
//         open={loading}
//       >
//         <CircularProgress color="inherit" />
//       </Backdrop>
//       <ToastMessage
//         message={toastMessage}
//         severity={toastSeverity}
//         open={openToast}
//         handleClose={handleToastClose}
//       />
//       <ExitModal
//         savemodal={exitModal}
//         setDeleteConfirmationModal={setDeleteConfirmationModal}
//         setModalOpen={setExitModal}
//         onExit={onExit}
//       />
//       <DeleteConfirmation
//         savemodal={deleteconfirmationModal}
//         setModalOpen={setDeleteConfirmationModal}
//         onExit={deleteStream}
//       />
//       <ConfirmReviewModal
//         isOpen={showPopup}
//         onClose={() => setShowPopup(false)}
//         onConfirm={() => {
//           trigeerReview();
//           setShowPopup(false);
//         }}
//       />
//     </>
//   );
// };

// export default SideFrame;


import React, { useEffect, useRef, useState } from "react";
import blinkshare from "../../../assets/patientcharts/blinkscribe 2.svg";
import recordbutton from "../../../assets/patientcharts/recordbutton.png";
import redwave from "../../../assets/patientcharts/redwave.png";
import messageIcon from "../../../assets/patientcharts/mingcute_more-3-fill.svg";
import TypeofVisitPop from "./TypeofVisitPop";
import { useNavigate } from "react-router-dom";
import redcircle from "../../../assets/audio/redcircle.png";
import pause from "../../../assets/audio/Pause.png";
import play from "../../../assets/audio/play.png";
import stop from "../../../assets/audio/ion_stop.png";
import redmic from "../../../assets/audio/redmic.png";
import RecordRTC, { StereoAudioRecorder } from "recordrtc";
import ExitModal from "../overlays/exitmodal";
import ReactiveWaves from "../../../streaming/reactivewaves";
import blinkscribeapi from "../../../api/blinkscribeapi";
import DeleteConfirmation from "../overlays/deleteconformation";
import useAudioRecorder from "../../../blinkscribe/audiorecorderhook";
import { Backdrop, CircularProgress, Popover } from "@mui/material";
import { saveAudioInIndexDB } from "../../../offlinestreaming/offlineBlobHandler";
import NurseAssistant from "../../../../src/assets/Signin/nurseassistant.svg";
import api from "../../../api/api";
import TimerOffIcon from "@mui/icons-material/TimerOff";
import { generateFilename } from "../../../utils/generatefilename";
import { eventBus } from "../../../utils/eventBus";
import ToastMessage from "../../../utils/mui/righttoptoast";
import { useSelector } from "react-redux";
import { ChatIcon, GoogleIcon, orangetick } from "./svg";
import ConfirmReviewModal from "./googleModal";
import AddIcon from "@mui/icons-material/Add";
import { set } from "date-fns";
import DiagnosisPopup from "../../../orders/popups/diagnosispopup";
import CallIcon from '@mui/icons-material/Call';
import dayjs from "dayjs";
import CustomDropdown from "../../../sidenavs/orders/CustomDropdown";
import { updatelov2Value, updatelovValue, updateTov2Value, updateTovValue } from "../../../reduxtoolkit/dump";
import { useDispatch } from "react-redux";
import { X } from "@mui/icons-material";
import { crossIcon } from "../../modals/svgs";
// import TypeofVisitPop from 'defaultLanding/overlays/TypeofVisit';
const SideFrame = ({
  audiotabchange,
  onClose,
  currentTab,
  setFetchedData,fetchedData,
  pendingActionRef ,
  isreocrdingdisabled,
 fetchpcarddata,

  data,setChat
}) => {
  const [percentage, setPercentage] = useState(20);
  const [activeButton, setActiveButton] = useState(3);
  const [loading, setLoading] = useState(false);
  const [TypeofVisit, setTypeofVisit] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
    const [diagnosispopup, setisDiagnosisPopup] = useState(false);
  const practiseid = window.getPracticeId();
  const [initialData, setInitialData] = useState([]);
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
const [showTooltip, setShowTooltip] = useState(false);
const [showTick, setShowTick] = useState(false);
const pollRef = useRef(null);

  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );
 const homescreenprev = useSelector(
    (state) => state.userPrivileges.homescreen
  );
  useEffect(()=>{
    console.log(tovValue,'tovv')

  },[tovValue])
  const navigate = useNavigate();
  const [isPaused, setIsPaused] = useState(false);
  const [exitModal, setExitModal] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [streamfilename, setStreamfilename] = useState("");
  const [patientName, setPatientName] = useState("");
  const [patientId, setPatientId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [deleteconfirmationModal, setDeleteConfirmationModal] = useState(false);
  const user = useRef("");
  const [connectionStatus, setConnectionStatus] = useState("Disconnected");
  const [elapsedTime, setElapsedTime] = useState(0); // Total elapsed time in seconds
  const startTimeRef = useRef(null); // Tracks the timer's start/resume time
  const timerRef = useRef(null); // Reference to the timer interval
  const audioStreamRef = useRef(null);
   const userConfig = useSelector((state) => state.userconfig);
  const [isError, setIsError] = useState(false);
  const streamname = useRef();
  const [isblockrecording,setIsBlockRecording]=useState(false)
  const pausedref = useRef(false);
   const [alertmessage, setAlertMessage] = useState("");
    const [severity, setSeverity] = useState("success");
    const [open, setOpen] = useState(false);
  const lov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov2")?.value
  );
  const tov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov2")?.value
  );
  const orders = useSelector((state) => state.orders.orders);
  const attemptsRef = useRef(0);
  const blocker = useRef(false);
  const wsRef = useRef(null);
  const ismanualstop = useRef(false);
  const ismanualrecordstart = useRef(false);
  const [alertMode, setAlertMode] = useState(true);
  const token = localStorage.getItem("auth");
    const [extraAnchorEl, setExtraAnchorEl] = useState(null);
      const extraOpen = Boolean(extraAnchorEl);
   const handleOpenExtra = (e) => setExtraAnchorEl(e.currentTarget);
  const handleCloseExtra = () => setExtraAnchorEl(null);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
const [pollTrigger, setPollTrigger] = useState(0);
  const dispatch = useDispatch();
  const [toastSeverity, setToastSeverity] = useState("success");
  const [showPopup, setShowPopup] = useState(false);
  const handleToastClose = () => {
    setOpenToast(false);
  };
    const handlealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
   const handleChange = (newValue) => {
    const numericValue = Number(newValue);
    dispatch(updatelovValue(numericValue));
    updatelovtov(numericValue,tovValue)
  };

  const handletovChange = (newValue) => {
    dispatch(updateTovValue(newValue));
    updatelovtov(lovValue,newValue)
  };

  const handleChange2 = (newValue) => {
    const numericValue = Number(newValue);
    dispatch(updatelov2Value(numericValue));
    updatelov2();
  };

  const handletov2Change = (newValue) => {
    dispatch(updateTov2Value(newValue));
  };
  const onSaving = (blob) => {
    if (blob && blob.type.startsWith("audio/")) {
      console.log("Valid audio blob:", blob);
      // Call the function to submit the audio blob
      if (blocker.current) {
        return;
      }
      console.log("submitting blob");
      submitAudioBlobManually(blob);
    } else {
      console.error("Invalid blob. Not an audio file.");
    }
  };


  useEffect(() => {
  const payload = {
    filter_array: {
      date_filter: {
        start_date: dayjs().format("YYYY-MM-DD"),
        end_date: dayjs().format("YYYY-MM-DD"),
      },
    },
  };

  const checkRecording = async () => {
    const res = await blinkscribeapi.post(
      `/v1/patient/${data.patientid}/recording/details`,
      payload
    );
console.log('checking for summarized')
    if (res.status !== 200) return;

    const list = res.data || [];

    // 1️⃣ no record today → no tick
    // if (!list.length) {
    //   setShowTick(false);
    //   return;
    // }
    if (!list.length) {
      setShowTick(false);
      clearInterval(pollRef.current);
      return;
    }

    // 2️⃣ find latest record using ts
    const latest = list.sort(
      (a, b) => dayjs(b.ts).valueOf() - dayjs(a.ts).valueOf()
    )[0];

    // 3️⃣ summarized → tick & stop loop
    if (latest.transcriptionstatus === "Summarized") {
      setShowTick(true);
      clearInterval(pollRef.current);
    } else {
      setShowTick(false);
    }
  };

  // 🔹 first call
  checkRecording();

  // 🔹 start loop
  // pollRef.current = setInterval(checkRecording, 3000);
if (++attemptsRef.current > 60) {   // ~3 min cap
  clearInterval(pollRef.current);
  return;
}

  return () => clearInterval(pollRef.current);
}, [data.patientid,pollTrigger]);

  const {
    manualrecord,
    stopmanualRecording,
    pausemanualRecording,
    resumemanualRecording,
  } = useAudioRecorder(onSaving);
  const recorderRef = useRef(null);
  const handleButtonClick = (index) => {
    setActiveButton(index);
  };

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  const submitAudioBlobManually = async (blob) => {
     pendingActionRef.current=false
    try {
      console.log("inserting into index db ...");
      console.log("userid", user.current.id);
      saveAudioInIndexDB({
        file: blob,
        practiceid: user.current?.config?.practiceid,
        departmentid: user.current?.config?.departmentid,
        patientid: data?.patientid,
        notes: "testing data",
        tags: "tagsdata",
        patientname: `${data?.firstname} ${data?.lastname}`,
        role: "PRO",
        filename: streamname.current,
        appointmentid: data?.appointmentid,
        userid: user.current?.id,
        templatename: "HnP",
      });
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const circleStyle = {
    background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${
      percentage * 3.6
    }deg)`,
  };
  const togglePause = () => {
    if (isPaused) {
      // Resume the timer
      pausedref.current = false;
      if (ismanualrecordstart) {
        resumemanualRecording();
      }

      startTimer();
    } else {
      // Pause the timer
      pausedref.current = true;

      if (ismanualrecordstart) {
        pausemanualRecording();
      }
      stopTimer();
    }
    setIsPaused((prev) => !prev);
  };
  const startRecording = async () => {
    pausedref.current = false;
    pendingActionRef.current=true
    try {
      setLoading(true);
      const response = await blinkscribeapi.get("/auth/me");
      user.current = response;
      setLoading(false);
      const filenamee = crypto.randomUUID();
      setStreamfilename(filenamee);
      streamname.current = filenamee;
      const notes = "Sample notes";
      const tags = "Sample tags";
      let patientname = `${data?.firstname} ${data?.lastname}`;
      const practiseid = window.getPracticeId();
      let departmentid = response?.config?.departmentid;
      setPatientId(data?.patientid);
      const appointmentid = String(data?.appointmentid || "").trim();

      const generatedfilename = generateFilename({
        practiceid: practiseid,
        departmentid: departmentid,
        patientid: data?.patientid,
        currentUser: "PRO",
        fileExtension: "txt",
        appointmentid: appointmentid,
      });

      let queryString = `token=${token}&stream_filename=${filenamee}&generated_file_name=${generatedfilename}&practiceid=${practiseid}&departmentid=${departmentid}&patientid=${
        data?.patientid
      }&appointmentid=${appointmentid}&template_name=${"HnP"}&notes=${encodeURIComponent(
        notes
      )}&tags=${encodeURIComponent(tags)}&patientname=${encodeURIComponent(
        patientname
      )}`;

      const ws = new WebSocket(
        `${window.location.protocol === "https:" ? "wss" : "ws"}://${window.location.host}/v2/bs/v1/recording/streaming?${queryString}`
      );
      setIsRecording(true);
      wsRef.current = ws;

      ws.onopen = () => {
        setConnectionStatus("Connected");
        console.log("WebSocket connection established.");
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        manualrecord();
      };

      ws.onclose = () => {
        if (!ismanualstop.current) {
          ismanualrecordstart.current = true;
          console.log("manual record initiated");
          manualrecord();
        }
        setConnectionStatus("Disconnected");
        console.log("WebSocket connection closed.");
      };

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      audioStreamRef.current = stream;
      const recorder = new RecordRTC(stream, {
        type: "audio",
        recorderType: StereoAudioRecorder,
        mimeType: "audio/webm",
        timeSlice: 5000, // Send data every 5 seconds
        desiredSampRate: 48000,
        numberOfAudioChannels: 1,
        ondataavailable: async (blob) => {
          if (ws.readyState === WebSocket.OPEN && !pausedref.current) {
            try {
              const base64Data = await blobToBase64(blob);
              ws.send(base64Data);
            } catch (error) {
              console.error("Error converting blob to base64:", error);
            }
          }
        },
      });

      recorder.startRecording();
      recorderRef.current = recorder;

      setElapsedTime(0);
      startTimer();
      setIsRecording(true);
      setIsPaused(false);
    }catch (error) {
  console.error("Error starting recording:", error);

  // Check only for refresh token failure
  if (error?.message?.includes("Failed to refresh token")) {
    setToastSeverity("error");
    setToastMessage("Please contact the administrator");
    setOpenToast(true);
  }

  setConnectionStatus("Error");
  setLoading(false);
}

  };

  const deleteStream = async () => {
     pendingActionRef.current=false
    try {
      const response = await blinkscribeapi.post(
        `/v1/recording/streaming/cancel?stream_filename=${streamfilename}`
      );
      if (response.status === 200) {
        if (ismanualrecordstart.current) {
          blocker.current = true;
          stopmanualRecording();
        }
        stopRecording();
        setExitModal(false);
        setDeleteConfirmationModal(false);
        stopRecording();

        setToastSeverity("info");
        setToastMessage("Recording Cancelled Successfully");
        setOpenToast(true);
      } else {
        setDeleteConfirmationModal(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      blocker.current = false;
    }
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  };

  const startTimer = () => {
    startTimeRef.current = Date.now() - elapsedTime * 1000; // Adjust for any previously elapsed time
    timerRef.current = setInterval(() => {
      const timePassed = Math.floor((Date.now() - startTimeRef.current) / 1000);
      setElapsedTime(timePassed);
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(timerRef.current);
    timerRef.current = null;
  };
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => {
        resolve(reader.result.split(",")[1]);
      };
      reader.onerror = (error) => reject(error);
    });
  };
  const stopRecording = () => {
    ismanualstop.current = true;
    ismanualrecordstart.current = false;
    if (recorderRef.current) {
      recorderRef.current.stopRecording(() => {
        recorderRef.current = null;
      });
    }

    if (audioStreamRef.current) {
      audioStreamRef.current.getTracks().forEach((track) => track.stop());
      audioStreamRef.current = null;
    }

    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.close(1000, "Recording stopped by user");
    }
    stopTimer();
    setElapsedTime(0);
    setExitModal(false);
    setIsRecording(false);
    setIsPaused(false);
    setTimeout(() => {
      eventBus.emit("refreshDashboard");
    }, 6000);
  };
  // Calculate the position of the small circle
  const angle = percentage * 3.6; // In degrees
  const radians = (angle - 90) * (Math.PI / 180); // Convert to radians
  const radius = 35; // Radius of the ring (half the width/height of the ring)
  const smallCircleOffset = 8; // Offset to position the small circle
  // 2025-06-26T08:28:23
  const smallCircleStyle = {
    position: "absolute",
    top: `${60 + radius * Math.sin(radians) - smallCircleOffset}px`,
    left: `${60 + radius * Math.cos(radians) - smallCircleOffset}px`,
    width: "28px",
    height: "28px",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
  };

  const onExit = () => {
     pendingActionRef.current=false
    if (ismanualrecordstart.current) {
      stopmanualRecording();
    }

    setToastSeverity("success");
    setToastMessage("Recording Saved Successfully");
    setOpenToast(true);

    stopRecording();
    
      setTimeout(() => {
    setPollTrigger(prev => prev + 1);
  }, 8000);
  };

  const handleAlarmData = async ({ PateintData }, AlertCondition) => {
    try {
      const response = await api.put(
        `/v1/${practiseid}/checkin/patient/${PateintData.patientid}/update_alarm_alert`,
        {
          appointment_id: PateintData.appointmentid,
          emergency_alert: AlertCondition,
        }
      );
      if (response.status === 200) {
        console.log("Updated Successfully");
        handleAlertModeData(PateintData);
      } else {
        console.error("Failed ");
      }
    } catch (error) {
      console.error("Error unassigning room:", error);
    }
  };

  const handleAlertModeData = async (PateintData) => {
    try {
      const response = await api.post(
        `/v1/${practiseid}/checkin/patient/${PateintData.patientid}/get_sign_details`,
        {
          appointment_id: PateintData.appointmentid,
        }
      );
      if (response.status === 200) {
        console.log("Updated Successfully");
        setAlertMode(response.data?.emergency_alert);
      } else {
        console.error("Failed ");
      }
    } catch (error) {
      console.error("Error unassigning room:", error);
    }
  };

  const handleProviderShow = async ({ ProviderData }) => {
    try {
      const response = await api.put(
        `/v1/${practiseid}/checkin/patient/${ProviderData.patientid}/update_provider`,
        {
          appointment_id: ProviderData.appointmentid,
          provider_check: "true",
        }
      );
      if (response.status === 200) {
        console.log("Updated ProviderName Successfully");
      } else {
        console.error("Failed to Updated ProviderName Successfully");
      }
    } catch (error) {
      console.error("Error unassigning room:", error);
    }
  };
  //
  const checkblinkscribe=async()=>{
    try {
      await blinkscribeapi.get("/auth/me");
    } catch (error) {
       if (error?.message?.includes("Failed to refresh token")) {
    setIsBlockRecording(true)
  }
    }
  }
  const fetchData = async () => {
    try {
      const response = await api.get(
        `/v1/${practiseid}/orders/patient/${data?.patientid}/condition`
      );

      if (response.status === 200) {
        setInitialData(response.pConditions);
      }
    } catch (error) {
      console.error("Error fetching patient conditions:", error);
    } finally {
    }
  };
 const handlediagnosis = () => {
    setisDiagnosisPopup(true);
  };
  useEffect(() => {
    fetchData();
    checkblinkscribe()
  }, []);
  const trigeerReview = async () => {
    setLoading(true);
    try {
      const response = await api.post(
        `/v1/${practiseid}/patient/${data?.patientid}/notification/google-review`
      );
      if (response.status === 200) {
        setToastSeverity("success");
        setToastMessage(response?.message || "Notification Sent Successfully");
        setOpenToast(true);
      } else {
        setToastSeverity("info");
        setToastMessage(response?.message || "something went wrong");
        setOpenToast(true);
      }
    } catch (error) {
      console.log(error);
      setToastSeverity("error");
      setToastMessage(error?.message || "something went wrong");
      setOpenToast(true);
    } finally {
      setLoading(false);
    }
  };
    const getorders = async (x) => {
      try {
        const selectedsuggestions = await api.post(
          `/v1/${practiseid}/orders/patient/${data.patientid}/get-orders`,
          {
            appointmentid: data.appointmentid,
            // "orderdate": data.created_at ? new Date(data.created_at).toISOString().split('T')[0] : "Invalid date"
            orderdate:data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
  
          }
        );
        if (selectedsuggestions.status === 200) {
          const lovtovItem = selectedsuggestions?.data?.lovtov?.[0];
          // if (!x) {
          //   if (lovtovItem) {
          //     dispatch(updatelovValue(lovtovItem.lov));
          //     dispatch(updateTovValue(lovtovItem.tov));
          //     dispatch(updatelov2Value(lovtovItem.lov2));
          //     dispatch(updateTov2Value(lovtovItem.tov2));
          //   } else {
          //     // Optional: set defaults if needed
          //     dispatch(updatelovValue(null));
          //     dispatch(updateTovValue(null));
          //     dispatch(updatelov2Value(null));
          //     dispatch(updateTov2Value(null));
          //   }
          // }
  
          // const suggestionList = selectedsuggestions.data?.look || [];
          // setGetOrdersData(selectedsuggestions?.data);
          // setSelectedSuggestionList(suggestionList);
          // setReferals(selectedsuggestions.data?.referrals || []);
          return selectedsuggestions?.data;
        }
      } catch (error) {
        console.log(error);
      }
    };
  
  const updatedashboard=async(x)=>{
     const payload = {
                    patientid: data.patientid,
                    orderdate:   data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
                  };
       const ordersresp= await api.post(`/v1/${practiseid}/orders/get`, payload);
                  if(ordersresp.status==200){
                    const apiOrders = ordersresp.data; 
const visitTypeOrder = apiOrders.find(
  (order) => order.ordertype === "VISIT"
);

if (visitTypeOrder?.id&&x) {
  await api.put(
    `/v1/${practiseid}/orders/${data.patientid}/update-visit-order/${visitTypeOrder.id}`,{
      ordername:x
    }
  );
     eventBus.emit("fetchSummary")
}
// Replace orders for the correct patient
const updated = fetchedData?.map((patient, idx) => {
;

  if (patient.patientid === data.patientid) {


    const updatedPatient = {
      ...patient,
      orders: apiOrders, // <-- DIRECT REPLACE
    };


    return updatedPatient;
  }


  return patient;
});



setFetchedData(updated);
  }
}
  const updatelovtov=async(lov,tov)=>{
    console.log(lovValue,tovValue,'lovtovsss')
      try {
        setLoading(true)
         const getorder = await getorders("block");
        const payload = {
        patientid: data.patientid,
        orderdate:data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),

      };

      const getordersss = await api.post(
        `/v1/${practiseid}/orders/get`,
        payload
      );
      let hasVisitOrder;
      if (getordersss.status === 200) {
        hasVisitOrder = getordersss?.data.some(
          (order) => order.ordertype === "VISIT"
        );
      } else {
        hasVisitOrder = false;
      }
  if (tov && hasVisitOrder) {
        if (
          tov=== getorder?.lovtov[0]?.tov &&
          lov === getorder?.lovtov[0]?.lov
        ) {
        } else {
         const response= await api.put(
            `/v1/${practiseid}/patient/${data.patientid}/orders/lovtov/update`,
            {
              patientname: `${data.firstname || ""} ${
                data.lastname || ""
              }`.trim(),
              orderdate:
             data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),

              lov: lov,
              ordlist: tov,
              task: "VISIT",
              loginuser: userConfig?.username,
              user_role: "ALL",
            }
          );
             if(response.status==200){
            
            
               updatedashboard(tov)
                  
                setToastSeverity("success");
        setToastMessage(response?.message || "Type of Visit Updated Successfully");
        setOpenToast(true);
          }else{
                setToastSeverity("info");
        setToastMessage(response?.message || "Something Went Wrong");
        setOpenToast(true);
          }
        }
      } else if(tovValue) {
     
        const createResponse = await api.post(
          `/v1/${practiseid}/patient/${data.patientid}/orders/create`,
          {
            department_id: userConfig?.config?.departmentid,
            patient_name: `${data.firstname || ""} ${
              data.lastname || ""
            }`.trim(),
            tov: tov, // purpose
            lov: data.lov,
            diagnosis: "",
            ordertype: "VISIT", // tabs
            ordername: tov, // buttons
            schedule: 'f', // t/f-schedule
            // provider: data.linked_provider,
            provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
            status: "CREATED",
            confirm_status: "E", // C/E
            orderdate:
           data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
            encounterid: 0,
          }
        );
           if(createResponse.status==200){
            
            
               updatedashboard()
                  
                setToastSeverity("success");
        setToastMessage(createResponse?.message || "Type of Visit Updated Successfully");
        setOpenToast(true);
          }else{
                setToastSeverity("info");
        setToastMessage(createResponse?.message || "Something Went Wrong");
        setOpenToast(true);
          }
      }
      } catch (error) {
        console.log(error)
           setToastSeverity("error");
        setToastMessage("Something Went Wrong");
        setOpenToast(true);
      }finally{
        setLoading(false)
      }
    }
const updatelov2=async()=>{
  try {
    setLoading(true)
   const response= await api.put(
            `/v1/${practiseid}/orders/update/patient/${data.patientid}/secondtovtask`,
            {
              task: "VISIT",
              orderdate:
        data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
              lov2: lov2Value,
              tov2: tov2Value,
            }
          )
          if(response.status==200){
            
            
               updatedashboard()
                  
                setToastSeverity("success");
        setToastMessage(response?.message || "Type of Visit Updated Successfully");
        handleCloseExtra();
        setOpenToast(true);
          }else{
                setToastSeverity("info");
        setToastMessage(response?.message || "Something Went Wrong");
        setOpenToast(true);
          }
  } catch (error) {
    console.log(error)
      setToastSeverity("error");
        setToastMessage("Something Went Wrong");
        setOpenToast(true);
  }finally{
setLoading(false)
  }
}

    const tovOptions = [
    "New Patient",
    "Follow up",
    "Consultation",
    "Wellness Commercial",
    "Wellness Medicare",
    "Others",
    "Nurse Visit",
    "Labs",
  ].filter((option) => option !== tovValue);
  return (
    <>
      <div
        className={`relative flex  lg:flex-col items-center lg:gap-4 gap-8 p-4 h-full bg-[#fafaf9] shadow-[0px_14px_42px_rgba(8,15,52,0.06)] transition-all duration-300 ease-in-out ${
          isCollapsed ? "w-16 lg:w-16" : "w-full lg:w-auto min-h-screen max-h-screen "
        }`}
      >
        {/* Orange Slider Button */}
        <button
          onClick={toggleCollapse}
          className="absolute bottom-2 left-12 lg:bottom-auto lg:top-4 lg:left-auto lg:-right-3 w-6 h-6 bg-[#E17954] rounded-full flex items-center justify-center shadow-lg transition-colors duration-500 z-2"
        >
          <svg
            className={`w-4 h-4 text-white transition-transform duration-300 ${
              isCollapsed ? "rotate-180" : "rotate-0"
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        {/* <button className="flex justify-center  items-center gap-[8px] text-xs w-[55px] h-[20px] p-[2px_16px] rounded-[18px] bg-[rgba(226,165,165,0.65)] text-[#EB5757] self-start">
                Close
            </button> */}
        {!isCollapsed && (
          <div className="w-[20%] lg:w-auto items-center flex flex-col">
            {/* {alertMode === "true" || alertMode === "True" ? (
              <TimerOffIcon
                onClick={() => handleAlarmData({ PateintData: data }, "false")}
                className="absolute top-6 text-gray-500 cursor-pointer left-6"
              />
            ) : (
              <img
                onClick={() => handleAlarmData({ PateintData: data }, "true")}
                className="absolute top-6 cursor-pointer left-6"
                src={NurseAssistant}
                alt="%$"
              />
            )} */}
<div
  className="absolute top-6 left-6"
  onClick={() => setShowPopup(true)}
>
  <div className="relative inline-block group cursor-pointer">
    {GoogleIcon}

    <div
      className="
        pointer-events-none
        absolute top-1/2 -translate-y-1/2 
        left-8 lg:-left-3 lg:top-10
        bg-[#1D2951] text-white text-xs font-medium
        py-1.5 px-3 rounded-md
        opacity-0 group-hover:opacity-100
        transition-opacity duration-200
        whitespace-nowrap z-50
      "
    >
      Google Review
    </div>
  </div>
</div>
            {/* <div className="absolute top-6 lg:top-16 left-16 lg:left-6 group cursor-pointer">
              {ChatIcon} */}
              <div onClick={()=>{setChat(true)}} className="absolute top-6 lg:top-16 left-16 lg:left-6 group cursor-pointer">
                {ChatIcon}

                {/* Tooltip */}
                <div
                  className="
                  pointer-events-none
      absolute top-1/2 -translate-y-1/2 
      left-8 lg:-left-3 lg:top-10
     bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md
      opacity-0 group-hover:opacity-100 transition-opacity duration-200 
      whitespace-nowrap
    "
                >
                  Chat
                </div>
              </div>
            {/* </div> */}

<div
              className="relative flex justify-center items-center w-[90px] h-[90px] mt-1 mb-0"
              onMouseMove={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                setTooltipPos({
                  x: e.clientX - rect.left,
                  y: e.clientY - rect.top + 15,
                });
              }}
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
              <div
                onClick={() => {
                  if (homescreenprev.includes("P-Card")) {
                    fetchpcarddata(data.id);
                    onClose();
                  }
                }}
                className="relative cursor-pointer flex justify-center items-center"
              >
                <img
                  src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
                  alt="profile"
                  onError={(e) =>
                    (e.target.src =
                      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
                  }
                  className="flex justify-center items-center w-[65px] h-[65px] border-2 rounded-[14px]"
                  style={{ border: `3.5px solid #${data.deductiblemet}` }}
                />
                {showTick && (
                  <div
                    className="absolute -top-2 -right-2 w-6 h-6 rounded-full
                    flex justify-center items-center bg-[#E17954]"
                  >
                    {orangetick}
                  </div>
                )}
              </div>

              {showTooltip && (
                <div
                  className="absolute bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md pointer-events-none whitespace-nowrap"
                  style={{
                    left: tooltipPos.x,
                    top: tooltipPos.y,
                    transform: "translate(-50%, 0)",
                  }}
                >
                  Pcard
                </div>
              )}
            </div>


            <div className="flex flex-col items-center mb-0">
              <div className="font-bold text-[#202020] text-sm text-center">
                {data?.firstname + " " + data.lastname || "-"}
              </div>
                    {data?.
              phone?<> <div className="mt-1 text-[#7E7E7E] font-inter   font-medium text-xs">
                            
                            <CallIcon sx={{fontSize:"15px"}}/>        {data?.phone || "-"}
                                  </div></>:<>
              </>}
              <div className="font-medium text-[#7e7e7e] text-[13px] text-center ">
                #{data?.patientid || "-"}
              </div>
              {/* <div className="font-medium text-[#7e7e7e] text-[13px] text-center ">
                {data?.dob || "-"}
              </div> */}
            </div>
          </div>
        )}

        {/* Collapsed State - Show only essential elements */}
        {isCollapsed && (
          <div className="flex flex-col items-center mt-6 h-full w-full gap-4">
            <div className="cursor-pointer group" onClick={() => setShowPopup(true)}>
              {GoogleIcon}
                <div
                  className="
                  pointer-events-none
      absolute top-1/2 -translate-y-1/2 
      left-8 lg:-left-3 lg:top-10
     bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md
      opacity-0 group-hover:opacity-100 transition-opacity duration-200 
      whitespace-nowrap z-50
    "
                >
                  Google Review
                </div>
            </div>
            <div className="relative group cursor-pointer">
              {ChatIcon}
              <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 -top-8 bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                Chat
              </div>

            </div>

            {/* Profile Picture - Smaller version */}

            <div className="relative flex justify-center items-center w-[50px] h-[50px]">
              <div
                onClick={() => {
                  if (homescreenprev.includes("P-Card")) {
                    fetchpcarddata(data.id);
                    onClose();
                  }
                }}
                className="relative flex justify-center cursor-pointer items-center"
              >
                <img
                  src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
                  alt="profile"
                  onError={(e) =>
                    (e.target.src =
                      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
                  }
                  className="flex justify-center items-center w-[45px] h-[45px]  border-2 border-[pink] rounded-[14px]  "
                  style={{ border: `2px solid #${data.deductiblemet}` }}
                />
              </div>
            </div>

            {!isRecording ? (
              <div className="flex">
                <div
                  className={`w-10 h-10 cursor-pointer ${
                    isreocrdingdisabled ||isblockrecording
                      ? "opacity-50 "
                      : ""
                  }`}
                  onClick={() => {
                    if(isblockrecording){
                        setToastSeverity("error");
    setToastMessage("Please contact the administrator");
    setOpenToast(true);
    return
                    }
                    if (!isreocrdingdisabled ) {
                      handleProviderShow({ ProviderData: data });
                      startRecording();
                    }
                  }}
                >
                  <img src={redmic} className="w-[35px] h-[35px]" alt="Mic" />
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center gap-2">
                {/* Pause/Play Button */}
                <div className="relative cursor-pointer" onClick={togglePause}>
                  <img
                    src={redcircle}
                    alt="Red Circle"
                    className="w-[30px] h-[30px]"
                  />
                  <img
                    src={!isPaused ? pause : play}
                    alt="Pause/Play"
                    className="absolute inset-0 m-auto w-[15px] h-[15px]"
                  />
                </div>

                {/* Recording Time Display */}
                <div
                  className="text-black font-normal text-xs"
                  style={{ fontFamily: "Inter" }}
                >
                  {formatTime(elapsedTime)}
                </div>

                {/* Stop Button */}
                <div
                  className="relative cursor-pointer"
                  onClick={() => {
                    if (!isPaused) {
                      stopTimer();
                      pausedref.current = false;
                      setIsPaused(true);
                      if (isError) {
                        pausemanualRecording();
                      }
                    }
                    setExitModal(true);
                  }}
                >
                  <img
                    src={redcircle}
                    alt="Red Circle"
                    className="w-[30px] h-[30px]"
                  />
                  <img
                    src={stop}
                    alt="Stop"
                    className="absolute inset-0 m-auto w-[15px] h-[15px]"
                  />
                </div>
              </div>
            )}

            {/* User Icon */}
            <div
              className="flex justify-center items-center w-8 h-8 cursor-pointer hover:bg-gray-100 rounded-lg transition-colors duration-200"
              onClick={toggleCollapse}
            >
              <svg
                width="19"
                height="18"
                viewBox="0 0 19 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.5 16.5C13.6421 16.5 17 13.1421 17 9C17 4.85786 13.6421 1.5 9.5 1.5C5.35786 1.5 2 4.85786 2 9C2 13.1421 5.35786 16.5 9.5 16.5Z"
                  stroke="#202224"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.5 9.75C10.7426 9.75 11.75 8.74264 11.75 7.5C11.75 6.25736 10.7426 5.25 9.5 5.25C8.25736 5.25 7.25 6.25736 7.25 7.5C7.25 8.74264 8.25736 9.75 9.5 9.75Z"
                  stroke="#202224"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.75 15.4965V14.25C5.75 13.8522 5.90804 13.4706 6.18934 13.1893C6.47064 12.908 6.85218 12.75 7.25 12.75H11.75C12.1478 12.75 12.5294 12.908 12.8107 13.1893C13.092 13.4706 13.25 13.8522 13.25 14.25V15.4965"
                  stroke="#202224"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            {/* Calendar Icon */}
            <div
              className="flex justify-center items-center w-8 h-8 cursor-pointer hover:bg-gray-100 rounded-lg transition-colors duration-200"
              onClick={toggleCollapse}
            >
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.1665 1.66669V5.00002"
                  stroke="#1E2A4A"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.8335 1.66669V5.00002"
                  stroke="#1E2A4A"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.3333 3.33331H4.66667C3.74619 3.33331 3 4.07951 3 4.99998V16.6666C3 17.5871 3.74619 18.3333 4.66667 18.3333H16.3333C17.2538 18.3333 18 17.5871 18 16.6666V4.99998C18 4.07951 17.2538 3.33331 16.3333 3.33331Z"
                  stroke="#1E2A4A"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M3 8.33331H18"
                  stroke="#1E2A4A"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            {/* Number Button */}
            <div className="flex justify-center items-center">
              <button
                className={`w-8 h-8 rounded-lg shadow-[0px_0px_4px_2px_#0000001a] flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity duration-200 ${
                  lovValue === 3
                    ? "bg-[#e17954] text-white"
                    : "bg-white text-[#1d2951]"
                }`}
                onClick={toggleCollapse}
              >
                <div className="font-bold text-xs">{lovValue}</div>
              </button>
            </div>

            {/* DX Text */}
            <div
              className="flex justify-center items-center cursor-pointer hover:bg-gray-100 rounded-lg transition-colors duration-200 px-2 py-1"
              onClick={handlediagnosis}
            >
              <div  className="text-[#1E2A4A] font-medium text-xs font-font1 ">
                DX
              </div>
            </div>
          </div>
        )}

        {!isCollapsed && (
          <div className="flex-grow flex lg:flex-col lg:gap-0 gap-10 items-center  max-h-[65%] custom-scrollbar">
            <div>
              <div className="w-full flex justify-center items-center p-0 mt-2 mb-2">
                <img
                  src={blinkshare}
                  alt=""
                  className="max-w-full max-h-[150px] object-contain"
                />
              </div>
              <div className="w-full flex justify-center items-center">
                {!isRecording ? (
                  <div className="flex">
                    <div className="w-12 h-12 cursor-pointer">
                      <div
                        className={` ${
                          isreocrdingdisabled ||isblockrecording
                            ? "opacity-50 "
                            : " cursor-pointer"
                        }`}
                        onClick={() => {
                             if(isblockrecording){
                        setToastSeverity("error");
    setToastMessage("Please contact the administrator");
    setOpenToast(true);
    return
                    }
                          if (!isreocrdingdisabled ) {
                            handleProviderShow({ ProviderData: data });
                            startRecording();
                          }
                        }}
                      >
                        <img
                      
                          src={redmic}
                          className="w-[40px] h-[40px] md:w-[50px] md:h-[50px]"
                          alt="Mic"
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="flex gap-4 items-center">
                    {/* Pause/Play Button */}
                    <div
                      className="relative cursor-pointer"
                      onClick={togglePause}
                    >
                      <img
                        src={redcircle}
                        alt="Red Circle"
                        className="w-[35px] h-[35px]"
                      />
                      <img
                        src={!isPaused ? pause : play}
                        alt="Pause/Play"
                        className="absolute inset-0 m-auto w-[20px] h-[20px]"
                      />
                    </div>

                    {/* Recording Time Display */}
                    <div className="flex flex-col items-center h-[90%] justify-between">
                      <div className="h-4 overflow-hidden">
                        <ReactiveWaves
                          isPaused={!isPaused}
                          mediaStream={audioStreamRef.current}
                        />
                      </div>
                      <div
                        className="h-3 text-black font-normal"
                        style={{ fontFamily: "Inter" }}
                      >
                        {formatTime(elapsedTime)}
                      </div>
                    </div>

                    {/* Stop Button */}
                    <div
                      className="relative cursor-pointer"
                      onClick={() => {
                        if (!isPaused) {
                          stopTimer();
                          pausedref.current = false;
                          setIsPaused(true);
                          if (isError) {
                            pausemanualRecording();
                          }
                        }
                        setExitModal(true);
                      }}
                    >
                      <img
                        src={redcircle}
                        alt="Red Circle"
                        className="w-[35px] h-[35px]"
                      />
                      <img
                        src={stop}
                        alt="Stop"
                        className="absolute inset-0 m-auto w-[20px] h-[20px]"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* content */}
            <div className="flex flex-col w-full gap-4 mt-4 px-2">
              {/* Provider Section */}
              <div className="flex flex-col items-start w-full">
                <div className="font-medium font-inter text-[#7E7E7E] text-[12px]">
                  Provider
                </div>
                <div className="font-medium font-inter text-[#202020] text-[14PX] mt-1">
                  {data?.linked_provider || "-"}
                </div>
              </div>

              {/* Healthcare Section */}
              <div className="flex flex-col items-start w-full">
                <div className="font-medium font-inter text-[#7E7E7E] text-[12px]">
                  Healthcare
                </div>
                <div className="font-medium font-inter text-[#202020] text-[14PX] mt-1">
                  {data?.insurancename || "-"}
                </div>
              </div>

              {/* Type Of Visit Section */}
              <div className="flex flex-col items-start w-full">
                <div className="flex items-center justify-between w-full">
                  <div className="text-[#7E7E7E] text-[12px] font-inter font-[500] font-Font1 leading-[normal]">
                    Type Of Visit
                  </div>
              
                </div>
                <div className="flex justify-between font-inter items-center w-full mt-2">
                  <select
                    value={tovValue}
                    onChange={(e) => handletovChange(e.target.value)}
                    className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1d2951] text-[#000000] font-font1 text-[14px] leading-[normal]"
                  >
                    <option value="" disabled>
                      Select a Visit
                    </option>
                    <option
                      className="font-semibold cursor-pointer"
                      value="New Patient"
                    >
                      New Patient
                    </option>
                    <option
                      className="font-semibold cursor-pointer"
                      value="Follow up"
                    >
                      Follow up
                    </option>
                    <option
                      className="font-semibold cursor-pointer"
                      value="Consultation"
                    >
                      Consultation
                    </option>
                    <option
                      className="font-semibold cursor-pointer"
                      value="Wellness Commercial"
                    >
                      Wellness Commercial
                    </option>
                    <option
                      className="font-semibold cursor-pointer"
                      value="Wellness Medicare"
                    >
                      Wellness Medicare
                    </option>
                    <option
                      className="font-semibold cursor-pointer"
                      value="Others"
                    >
                      Others
                    </option>
                    <option
                      className="font-semibold cursor-pointer"
                      value="Nurse Visit"
                    >
                      Nurse Visit
                    </option>
                    <option className="font-semibold cursor-pointer" value="Labs">
                      Labs
                    </option>
                  </select>
                      
                </div>
                {/* Show secondary visit type as tag */}

              </div>

              {/* Level of Visit Section */}
              {(tovValue?.includes("New Patient") ||
                tovValue?.includes("Follow up") ||
                tovValue?.includes("Consultation")) && (
                <div className="flex flex-col items-start w-full">
                  <div className="flex items-center justify-between w-full">
                    <div className="text-[#1E2A4A] text-[13px] font-semibold font-Font1 leading-[normal]">
                      Level of Visit
                    </div>
                    {lovValue && (
                      <div className="text-[#E17954] font-semibold text-sm">
                        {lovValue === 1 ? "99211" : lovValue === 2 ? "99212" : lovValue === 3 ? "99213" : lovValue === 4 ? "99214" : "99215"}
                      </div>
                    )}
                  </div>
                  <div className="flex justify-start w-full mt-2 gap-1">
                    {[1, 2, 3, 4, 5]?.map((value) => (
                      <button
                        key={value}
                        onClick={() => handleChange(value)}
                        className={`px-[10px] py-[5px] text-xs font-bold border-[1px] border-[#ccc] rounded-lg ${
                          lovValue === value
                            ? "bg-[#E17954] text-white"
                            : "bg-[white] text-black"
                        } focus:outline-none`}
                        style={{ 
                          transition: "background-color 0.3s ease",
                          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.12)"
                        }}
                      >
                        {value}
                      </button>
                    ))}
                    <div
                    className="flex items-center cursor-pointer"
                    onClick={handleOpenExtra}
                  >
                    <AddIcon />
                  </div>
                  </div>
                </div>
              )}
              {(tovValue?.includes("Wellness Commercial") ||
                tovValue?.includes("Wellness Medicare")) && (
                <div className="flex flex-col items-start w-full">
                  <div className="text-[#1E2A4A] text-[13px] font-semibold font-Font1 leading-[normal]">
                    Level of Visit
                  </div>
                  <select
                    value={lovValue}
                    onChange={(e) => handleChange(e.target.value)}
                    className="w-full mt-2 px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="1">First</option>
                    <option value="2">Subsequent</option>
                  </select>
                </div>
              )}
                              {tov2Value && (
                  <div className="flex items-center w-fit px-3 py-1 mt-2 rounded-full border-[1px] border-[#E17954] bg-[#E179542E]">
                    <span className="text-xs font-medium font-inter text-[#7E7E7E]">
                      {tov2Value}
                    </span>
                    <span className="ml-2 flex items-center justify-center w-5 h-5 rounded-full bg-[#E17954] text-white text-xs font-bold shadow-sm">
                      {lov2Value || "-"}
                    </span>
                    <span className="ml-2 cursor-pointer text-[#E17954]"  onClick={() => {
                        dispatch(updateTov2Value(null));
                        dispatch(updatelov2Value(null));
                      }}>
                      {crossIcon}
                    </span>
                  </div>
                )}

              {/* Diagnosis Section */}
              <div className="flex flex-col items-start w-full">
                <div className="flex items-center justify-between w-full">
                  <div className="text-[#7E7E7E] text-[13px] font-semibold font-Font1 leading-[normal]">
                    Diagnosis
                  </div>
                  <div
                    className="flex items-center cursor-pointer"
                    onClick={handlediagnosis}
                  >
                    <AddIcon sx={{ fontSize: "22px" }} />
                  </div>
                </div>
                {orders?.diagnosis &&
                  orders.diagnosis.length > 0 && (
                    <div className="w-full mt-2">
                      <ul className="list-disc pl-4 space-y-3">
                        {orders.diagnosis?.map((condition) => (
                          <li
                            key={condition.id}
                            className="font-normal font-font1 text-left text-[#4B5563] text-[14px]"
                          >
                            {condition.condition_name}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
              </div>

              {/* Popover for additional visit types */}
              <Popover
                open={extraOpen}
                anchorEl={extraAnchorEl}
                onClose={handleCloseExtra}
  anchorOrigin={{ vertical: "top", horizontal: "right" }}
  transformOrigin={{ vertical: "center", horizontal: "left" }}
                PaperProps={{
                  sx: {
                    p: 2,
                    width: 260,
                    borderRadius: 2,
                    boxShadow: "0px 8px 24px rgba(0,0,0,0.12)",
                    position: "relative",
                    overflow: "visible",
                  },
                }}
              >
                <div className="text-[13px] font-medium text-[#7E7E7E] mb-2">
                  Type Of Visit
                </div>
                <CustomDropdown
                  options={tovOptions
                    .filter(
                      (o) =>
                        o === "Wellness Commercial" || o === "Wellness Medicare"
                    )
                    ?.map((o) => ({ value: o, label: o }))}
                  value={tov2Value}
                  onChange={handletov2Change}
                  placeholder="Select Type"
                />

                <div className="text-[12px] font-semibold text-[#1E2A4A] mb-1 mt-3">
                  Level of Visit
                </div>
                <CustomDropdown
                  options={[
                    { value: "1", label: "First" },
                    { value: "2", label: "Subsequent" },
                  ]}
                  value={lov2Value}
                  onChange={handleChange2}
                />

                {/* <div className="w-full mt-2">
                  <div
                    onClick={() => {
                      updatelov2();
                    }}
                    className="text-sm text-center cursor-pointer bg-black text-white px-2 py-1 rounded-md"
                  >
                    Update
                  </div>
                </div> */}
              </Popover>
            </div>
          </div>
        )}
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleToastClose}
      />
      <ExitModal
        savemodal={exitModal}
        setDeleteConfirmationModal={setDeleteConfirmationModal}
        setModalOpen={setExitModal}
        onExit={onExit}
      />
      <DeleteConfirmation
        savemodal={deleteconfirmationModal}
        setModalOpen={setDeleteConfirmationModal}
        onExit={deleteStream}
      />
 <DiagnosisPopup
        appid={data}
        flow='chart'
        setAlertMessage={setAlertMessage}
        setSeverity={setSeverity}
        setOpen={setOpen}
        isOpen={diagnosispopup}
        onClose={() => setisDiagnosisPopup(false)}
      />
        <ToastMessage
              message={alertmessage}
              severity={severity}
              open={open}
              handleClose={handlealert}
            />
      <ConfirmReviewModal
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        onConfirm={() => {
          trigeerReview();
          setShowPopup(false);
        }}
      />
    </>
  );
};

export default SideFrame;
